module.exports = __webpack_public_path__ + "img/square2.df56c034.svg";